<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar>
        <v-btn text :to="{name: 'AddOrganization'}">
          <v-icon class="mr-1">mdi-account-group</v-icon>
          Create new organization
        </v-btn>
    </SubTopBar>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        class="mt-1"
        large
        />
      <data-table 
        v-model="page" 
        class="row-pointer"
        :loading="dataLoading"
        :headers="headers"
        :items="items"
        @refresh="load"
        :rowClickEvent="rowOnClick"
      ></data-table>
    </template>
  </page>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      headers: [
        { text: "Organization name", align: "start", value: "globalid" },
        { text: "Role", value: "role" },
      ],
      items: [],
      loading: true,
      dataLoading: true
    }
  },
  computed: {
    bcItems: function () {
      return [
        {},
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  created: function () {
    this.load()
  },
  methods: {
    load() {
      this.$api.getUserOrganizations(this.username, this.callBack(
        response => {
          const allItems = []
          const flatten = (list, role) => {
            list.forEach(element => {
              allItems.push({globalid: element, role: role})
            })
          }
          flatten(response.member, "member")
          flatten(response.owner, "owner")
          allItems.sort((a,b) => a.globalid > b.globalid ? 1 : -1)
          const items = []
          allItems.forEach(element => {
            if (!/\./.test(element.globalid)) {
              items.push(element)
              return
            }
            var parentPresent = false
            items.forEach(parentElement => {
              if (element.globalid.startsWith(`${parentElement.globalid}.`)) parentPresent = true
            })
            if ( !parentPresent )
              items.push(element)
          })
          this.items = items
        }, undefined, ()=> {
          this.dataLoading = false
          this.loading = false
        }
      ))
    },
    rowOnClick: function (value) {
      if (value.role == "owner") {
        this.$router.push({ name: 'OrganizationPeople', params: { organization: value.globalid }})
      } else {
        this.$router.push({ name: 'OrganizationStructure', params: { organization: value.globalid }})
      }
    }
  }
}
</script>

<style scoped>
span {
  padding: 5px 5px;
}
.v-card {
  width: fit-content;
  margin: 4px;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>